import React from "react";
import logo from "./img/svg/stundji-logo.svg";
import Portfolio from "./Portfolio";

const logoSvg = `<svg
xmlns="http://www.w3.org/2000/svg"
width="300px"
height="50px"
viewBox="0 0 41.555271 5.4197011"
version="1.1"
id="svg8"
>
<g
  inkscape:label="Layer 1"
  inkscape:groupmode="layer"
  id="layer1"
  transform="translate(-90.347364,-154.43896)"
>
  <path
    id="stundji-path"
    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:25.39999962px;line-height:1.25;font-family:Tele-Marines;-inkscape-font-specification:'Tele-Marines, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;stroke:#ffffff;stroke-width:0.75;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
    d="M 150.75 0.37695312 L 147.53906 0.41210938 L 147.53906 10.244141 L 147.53906 13.521484 C 147.53906 15.706429 146.17259 16.798828 143.44141 16.798828 L 139.34375 16.798828 L 135.24805 16.798828 L 127.875 16.798828 L 127.875 20.076172 L 133.59375 20.076172 L 139.33008 20.091797 L 145.04883 20.091797 C 148.87248 20.101876 150.7832 18.467979 150.7832 15.191406 L 150.75 0.37695312 z M 102.4082 0.40820312 L 102.4082 2.8671875 L 102.4082 11.847656 L 105.68555 11.847656 L 105.68555 3.6894531 L 107.35742 3.6894531 L 113.86328 3.7050781 C 119.33657 3.6949994 122.07227 5.8731292 122.07227 10.242188 C 122.07227 14.612077 119.34126 16.796875 113.87891 16.796875 L 102.4082 16.796875 L 102.4082 20.074219 L 113.86328 20.089844 C 121.49967 20.099922 125.31836 16.827441 125.31836 10.273438 C 125.31836 3.7186029 121.52707 0.43004879 113.94531 0.40820312 L 102.4082 0.40820312 z M 54.654297 0.41015625 L 51.410156 0.4453125 L 51.410156 10.277344 C 51.410156 16.831322 55.22885 20.101876 62.865234 20.091797 C 70.501619 20.080861 74.318359 16.79895 74.318359 10.244141 L 74.318359 0.41210938 L 71.041016 0.41210938 L 71.058594 5.359375 L 71.058594 6.9980469 L 71.058594 10.259766 C 71.047684 14.618745 68.310031 16.796875 62.847656 16.796875 C 57.385307 16.796875 54.654297 14.612077 54.654297 10.242188 L 54.654297 0.41015625 z M 76.910156 0.41015625 L 76.910156 2.8691406 L 76.910156 5.3261719 L 76.910156 10.242188 L 76.910156 20.074219 L 80.154297 20.074219 L 80.169922 6.9980469 L 80.169922 5.359375 L 80.154297 3.6894531 L 88.363281 3.7050781 C 93.836591 3.6949994 96.562861 5.8731292 96.541016 10.242188 L 96.541016 20.107422 L 99.818359 20.107422 L 99.818359 10.275391 C 99.818359 3.720556 96.027095 0.43200192 88.445312 0.41015625 L 76.910156 0.41015625 z M 6.1152344 0.4453125 C 2.2915796 0.4453125 0.37890625 2.0838982 0.37890625 5.3613281 L 0.41210938 7.03125 L 0.41210938 11.882812 L 3.65625 11.882812 L 3.671875 6.1640625 C 3.6828004 4.5144247 4.4094989 3.6894531 5.8515625 3.6894531 L 8.0800781 3.6894531 L 23.353516 3.6894531 L 23.320312 0.4453125 L 11.849609 0.4453125 L 6.1152344 0.4453125 z M 25.910156 0.4453125 L 25.910156 3.7226562 L 35.775391 3.7226562 L 35.775391 20.076172 L 39.019531 20.076172 L 39.019531 3.7226562 L 48.853516 3.7226562 L 48.853516 0.4453125 L 25.910156 0.4453125 z M 153.40625 0.4453125 L 153.40625 20.076172 L 156.68359 20.076172 L 156.68359 0.4453125 L 153.40625 0.4453125 z M 20.042969 8.6386719 L 20.042969 14.339844 C 20.042969 16.000417 19.322926 16.832031 17.880859 16.832031 L 15.652344 16.832031 L 0.37890625 16.832031 L 0.41210938 20.076172 L 11.882812 20.076172 L 17.617188 20.076172 C 21.440845 20.076172 23.353516 18.437561 23.353516 15.160156 L 23.320312 13.488281 L 23.320312 8.6386719 L 20.042969 8.6386719 z "
    transform="matrix(0.26458333,0,0,0.26458333,90.347364,154.43896)"
  />
</g>
</svg>`;

function App() {
  return (
    <div>
      <div
        className="font_preload"
        style={{
          pointerEvents: "none",
          position: "absolute",
          opacity: 0,
        }}
      >
        <span style={{ fontFamily: "Lato" }}></span>
        <span
          style={{
            fontFamily: "Montserrat",
          }}
        ></span>
      </div>
      <div id="progressbar-wrapper" className="progressbar-wrapper">
        <div id="progressbar">
          <span dangerouslySetInnerHTML={{ __html: logoSvg }} />
        </div>
      </div>
      <div className="overlay-navigation">
        <div className="nav-box"></div>
        <nav id="navbar-responsive" className="navigation">
          <ul className="nav">
            <li data-url="nav_1">
              <a className="page-scroll" href="#about">
                About
              </a>
            </li>
            <li data-url="nav_2">
              <a className="page-scroll" href="#skills">
                Services
              </a>
            </li>
            <li data-url="nav_3">
              <a className="page-scroll" href="#portfolio">
                Work
              </a>
            </li>
            <li data-url="nav_4">
              <a className="page-scroll" href="#contact">
                Contact
              </a>
            </li>
          </ul>
        </nav>
        <div className="nav-line"></div>
      </div>
      <div className="nav-buttons">
        <a
          id="navlogo"
          className="navbrand page-scroll"
          href="#page-top"
          aria-label="Stundji"
        >
          <img src={logo} alt="Stundji" />
        </a>
        <div className="open-overlay">
          <span className="bar-top"></span> <span className="bar-middle"></span>
          <span className="bar-bottom"></span>
        </div>
      </div>
      <div className="app">
        <section id="header" data-section-name="page-top">
          <div className="header-content">
            <div className="overlay">
              <div className="box inn" data-speed="7"></div>
              <div className="box"></div>
            </div>
            <div className="overlay inn" data-speed="10"></div>
            <div className="scene">
              <div className="homeHeading-wrapper">
                <div className="signature-wrapper">
                  <div className="inn" data-speed="8">
                    <h2 className="signature d-in-bl" data-type="content">
                      Stanimir Spasov
                    </h2>
                    <div className="pane"></div>
                  </div>
                </div>
                <div id="homeHeading" className="d-in-bl" data-type="content">
                  <h2 className="inn" data-speed="4">
                    Dream it
                  </h2>
                  <h2 className="inn" data-speed="6">
                    Wish it
                  </h2>
                  <h2 className="inn" data-speed="8">
                    Do it
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="about" data-section-name="about-me">
          <div className="box inn" data-speed="4"></div>
          <div className="content">
            <div className="scene">
              <div className="pane inn" data-speed="10">
                <div className="flex flex-wrap col-sm-12 col-md-12 col-lg-11 col-lg-offset-1">
                  <div className="text-list">
                    <h2>I like helping people achieve their dreams</h2>
                    <p className="about">
                      I deliver full range of web and mobile services for your
                      unique ideas. My job as a designer and developer is not
                      only about fulfilling your goals - I embrace my commitment
                      to help you go beyond your full potential while diligently
                      serving the long-term vision of your brand.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="skills">
          <div className="overlay" data-speed="2"></div>
          <div className="pane inn" data-speed="6"></div>
          <div className="content">
            <div className="scene">
              <div>
                <div className="col-sm-12 col-md-12 col-lg-10 col-lg-offset-1">
                  <div className="skills-panel-wrapper">
                    <div className="skills-panel inn" data-speed="6">
                      <div className="panel-content">
                        <h4>Creative Design</h4>
                        <hr className="light" />
                        <p>
                          I help emerging and established companies gain the
                          recognition their business deserves. By using the
                          newest technologies I deliver a unique responsive
                          design matching own visual style and expressing brand
                          and identity in a perfect way. From minimalistic to
                          fully animated website, my goal is to inspire the
                          right people in the right places.
                        </p>
                      </div>
                      <div className="panel-img-wrapper sass">
                        <img
                          src={require("./img/sass-Logo.svg")}
                          alt="sass-logo"
                          width="400"
                        />
                      </div>
                    </div>
                    <div
                      className="skills-panel inn"
                      data-speed="8"
                      data-margin="75"
                    >
                      <div className="panel-content">
                        <h4>Limitless flexibility</h4>
                        <hr className="light" />
                        <p>
                          When it comes to speed and scalability, my clients
                          receive the fastest and most reliable applications out
                          there, because in this fast-paced world user
                          experience is a number one priority and a fast,
                          easy-to-use website or mobile app is always a better
                          choice.
                        </p>
                      </div>
                      <div className="panel-img-wrapper react">
                        <img
                          src={require("./img/react-Logo.svg")}
                          alt="react-logo"
                          width="400"
                        />
                      </div>
                    </div>
                    <div
                      className="skills-panel inn"
                      data-speed="10"
                      data-margin="150"
                    >
                      <div className="panel-content">
                        <h4>Fast delivery</h4>
                        <hr className="light" />
                        <p>
                          For me there is no standart 9 to 5 work day. I align
                          my work time with my clients to meet tighter goals and
                          achieve desirable results without compromising on
                          quality. Meeting my client's needs while keeping up
                          with his deadlines is a key element in my workflow.
                        </p>
                      </div>
                      <div className="panel-img-wrapper node">
                        <img
                          src={require("./img/node-Logo.svg")}
                          alt="angular-logo"
                          width="350"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="what-i-do" className="flex">
          <div className="info-wrapper">
            <div className="item-info item-info--1">
              <div className="flex align-items--center flex-grow--1 col-lg-offset-2 col-sm-offset-2 col-xs-offset-1">
                <p>
                  I create mobile friendly and fully-responsive website designs
                  for your needs. This includes taking the best out of user
                  experience, search engine optimization, ease of use, and
                  technical details - the most important things for a website to
                  perform good in today’s competitive marketplace.
                </p>
              </div>
              <div className="close-item">
                <span>
                  <img
                    src={require("./img/cross-circular.png")}
                    alt="close-item"
                  />
                </span>
              </div>
            </div>
            <div className="item-info item-info--2">
              <div className="flex align-items--center flex-grow--1 col-lg-offset-2 col-sm-offset-2 col-xs-offset-1">
                <p>
                  My web development techniques match the personalization of web
                  design with the compliance and responsive standards for fast,
                  clean code. I use the lastest and greatest technological tools
                  including React, Angular, NodeJS and SCSS to deliver you the
                  best possible product.
                </p>
              </div>
              <div className="close-item">
                <span>
                  <img
                    src={require("./img/cross-circular.png")}
                    alt="close-item"
                  />
                </span>
              </div>
            </div>
            <div className="item-info item-info--3">
              <div className="flex align-items--center flex-grow--1 col-lg-offset-2 col-sm-offset-2 col-xs-offset-1">
                <p>
                  If you’re looking to leverage mobile technology for your
                  business, I can build an application just for you. I provide
                  iOS and Android mobile application development services so you
                  can reach your customers on their favorite devices.
                </p>
              </div>
              <div className="close-item">
                <span>
                  <img
                    src={require("./img/cross-circular.png")}
                    alt="close-item"
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="flex-col justify-center">
            <ul className="list">
              <li className="item item--1">
                <span>Web design</span>
              </li>
              <li className="item item--2">
                <span>Web development</span>
              </li>
              <li className="item item--3">
                <span>Mobile applications</span>
              </li>
            </ul>
          </div>
          <div className="mask-wrapper">
            <div className="item--mask"></div>
            <div className="item-bg--1"></div>
            <div className="item-bg--2"></div>
            <div className="item-bg--3"></div>
          </div>
        </section>

        <section id="portfolio" data-section-name="my-work">
          <Portfolio />
        </section>

        <section id="contact" data-section-name="contact-me">
          <div className="overlay"></div>
          <div id="message">
            <div className="scene">
              <div>
                <div className="col-lg-8 col-lg-offset-2">
                  <div className="lines">
                    <h2 className="section-heading text-center contact-heading">
                      Get in touch with me
                    </h2>
                  </div>
                  <hr className="primary" />
                  <form id="messageMe" name="contactForm">
                    <div className="form-inline">
                      <div className="form-group">
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Your Name*"
                          required
                          aria-label="name"
                        />
                      </div>

                      <div className="form-group">
                        <input
                          type="email"
                          name="email"
                          className="form-control .eml"
                          placeholder="Your Email*"
                          aria-label="email"
                        />
                      </div>
                      <input
                        type="text"
                        name="subject"
                        className="form-control form-group sbj"
                        placeholder="Subject*"
                        required
                        aria-label="subject"
                      />
                    </div>

                    <textarea
                      id="inputMessage"
                      name="inputMessage"
                      className="form-control"
                      rows="12"
                      placeholder="Your Message*"
                      aria-label="your message"
                    ></textarea>

                    <div className="text-center alert"></div>
                    <button type="submit" className="stn-btn pull-right">
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="footer">
          <div className="footer-social col-lg-8 col-md-8 col-xs-12">
            <div className="col-xs-6 col-sm-2 col-md-2 col-lg-2 text-center soc-box">
              <i
                className="fa fa-facebook fa-3x sr-contact f-contact"
                aria-hidden="true"
              ></i>
              <p className="p-contact">
                <a
                  href="http://www.facebook.com/Stundji"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </p>
            </div>
            <div className="col-xs-6 col-sm-2 col-md-2 col-lg-2 text-center soc-box">
              <i className="fa fa-envelope-o fa-3x sr-contact f-contact"></i>
              <p className="p-contact">
                <a
                  href="mailto:stanimirrspasov@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Email
                </a>
              </p>
            </div>
            <div className="col-xs-6 col-sm-2 col-md-2 col-lg-2 text-center soc-box">
              <i
                className="fa fa-github fa-3x sr-contact f-contact"
                aria-hidden="true"
              ></i>
              <p className="p-contact">
                <a
                  href="https://github.com/Stundji"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
              </p>
            </div>
            <div className="col-xs-6 col-sm-2 col-md-2 col-lg-2 text-center soc-box">
              <i
                className="fa fa-linkedin fa-3x sr-contact f-contact"
                aria-hidden="true"
              ></i>
              <p className="p-contact">
                <a
                  href="https://www.linkedin.com/in/stanimir-spasov-498375121"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </p>
            </div>
          </div>
          <div className="footer-info col-lg-8">
            <img src={require("./img/stundji_logo_purple.png")} alt="Stundji" />
            <span className="footer-text"> Web Design and Development</span>
          </div>
          <div className="col-lg-8 text-center">
            <a href="#header" className="stn-btn btn-xl page-scroll">
              Go back
            </a>
          </div>
        </div>
        <div className="app-pane inn vert" data-speed="3"></div>
      </div>
    </div>
  );
}

export default App;
